// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { categoriesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { css } from "styled-components";

categoriesStyles.title = {
    variant: "h2",
};

categoriesStyles.categoryImage = {
    width: "120px",
    height: "120px",
};

categoriesStyles.categoryImageItem = {
    width: 12,
    align: "middle",
    css: css`
        max-height: 160px;
        min-height: 160px;
        padding-bottom: 12px;
    `,
};

categoriesStyles.categoryNameLink = {
    typographyProps: {
        variant: "p",
        weight: fontConfig.weight.bold,
        css: css`
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
        `,
    },
    color: "text.main",
    css: css`
        width: 100%;
    `,
};

categoriesStyles.categoryItemRow = {
    width: [6, 4, 4, 3, 2],
};
